import { createApi } from '@reduxjs/toolkit/query/react';
import {
  ServiceAttributes,
  ServiceData,
  ServiceListResponse,
  ServiceQuery
} from 'models/service';
import { baseQueryAuth, createQueryUrl } from 'utils/fetchUtils/fetchUtils';
import { trim } from 'utils/stringUtils';
import * as authService from 'services/authService/authService';
import { validateTokenSuccess } from 'store/authState/authState';

export const serviceApi = createApi({
  reducerPath: 'serviceApi',
  baseQuery: baseQueryAuth,
  tagTypes: ['Service'],
  endpoints: (builder) => ({
    getServicesList: builder.query<ServiceAttributes[], ServiceQuery>({
      query: ({ languageCode = 'en', countryCode }) =>
        createQueryUrl('/services', {
          langCode: trim(languageCode),
          countryCode: trim(countryCode)
        }),
      transformResponse: (res: ServiceListResponse) =>
        res.data.map((item) => item.attributes),
      providesTags: [{ type: 'Service' }]
    }),
    requestServiceAccess: builder.mutation<void, ServiceData>({
      async queryFn(data, { dispatch }, _extraOptions, baseQuery) {
        try {
          // Make the service access request
          const result = await baseQuery({
            url: '/services/request-access',
            method: 'POST',
            body: {
              data: {
                type: 'service',
                attributes: {
                  iamGroup: data.iamGroup
                }
              }
            }
          });

          if (result.error) {
            return { error: result.error };
          }

          // Get new user info after group has been added
          const response = await authService.getUserInfo();
          dispatch(validateTokenSuccess(response.data));

          // Return success
          return { data: undefined };
        } catch (error: any) {
          return { error: { status: 'CUSTOM_ERROR', error: error.message } };
        }
      },
      invalidatesTags: [{ type: 'Service' }]
    })
  })
});

export const { useGetServicesListQuery, useRequestServiceAccessMutation } =
  serviceApi;
